import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-tab-content',
  styleUrl: 'tabs.css',
  shadow: true,
})
export class TabContent {
  @Prop() name: string;

  render() {
    return (
      <Host id={this.name} class="content-area">
      <section role="tabpanel">
        <slot />
      </section>
      </Host>
    );
  }
}
